import { axiosInstance } from 'boot/axios';
import isEmpty from 'lodash/isEmpty';

export function getFinancialSummary({ commit, state }, payload) {
  if (state.financialSummaryByYearCustomer[`${payload.year}${payload.customerNumber}`]) return;

  const customerNumber = payload.customerNumber;
  const year = payload.year;

  commit('setIsLoadingFinancialSummary', true);

  axiosInstance
    .get(`/Policy/GetFinancialSummary?customerNumber=${customerNumber}&year=${year}`)

    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('addFinancialSummary', {
          customerNumber: customerNumber,
          year: year,
          financialSummary: response.data,
        });
      }
    })
    .finally(() => {
      commit('setIsLoadingFinancialSummary', false);
    });
}
